import React from 'react'

import MailToLink from '../MailToLink'

const PremiumOnly = ({ provider }) => (
    <div className="try-intento__input-control">
        This provider is not available in the trial mode. If you are interested
        in using it, please,{' '}
        <MailToLink
            title={`Web demo: ${provider.name} request`}
            content={`We'd like to use ${provider.name} in our projects. Our usecases are ...`}
        >
            sign a Commercial License Agreement
        </MailToLink>
        .
    </div>
)

export default PremiumOnly



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryError/PremiumOnly.jsx